import {createStrokeSVG} from './TEMPLATE'

// tabler: lock
export const Lock_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6',
    'M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0',
    'M8 11v-4a4 4 0 1 1 8 0v4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: lock
export const Lock_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6',
    'M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0',
    'M8 11v-4a4 4 0 1 1 8 0v4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: lock-open
export const Unlock_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -6',
    'M11 16a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
    'M8 11v-5a4 4 0 0 1 8 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
